import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatPresetSelectProps } from './chat-preset-select.interface';

const NONE_VALUE = '';

export function ChatPresetSelectComponent({
  presets,
  value,
  onChange,
  disabled,
}: ChatPresetSelectProps) {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      const nextValue = event.target.value;
      onChange(nextValue === NONE_VALUE ? null : nextValue);
    },
    [onChange],
  );

  return (
    <Select
      value={value ?? NONE_VALUE}
      onChange={handleChange}
      disabled={disabled}
      displayEmpty
      aria-label={t('chats.preset')}
      MenuProps={{
        slotProps: {
          paper: {
            sx: { fontSize: 14 },
          },
        },
      }}
      sx={{
        minWidth: 140,
        maxWidth: 240,
        height: 36,
        fontSize: 14,
        bgcolor: 'transparent',
        boxShadow: 'none',
        '& fieldset': { border: 'none' },
        '&:hover fieldset': { border: 'none' },
        '&.Mui-focused fieldset': { border: 'none' },
        '& .MuiSelect-select': {
          py: 0.5,
          px: 0.5,
          pr: '28px !important',
          bgcolor: 'transparent',
        },
        '& .MuiSelect-icon': {
          right: 0,
        },
        '&:hover': {
          bgcolor: 'transparent',
        },
      }}
    >
      <MenuItem value={NONE_VALUE} dense>
        {t('chats.noPreset')}
      </MenuItem>
      {presets.map((preset) => (
        <MenuItem key={preset.id} value={preset.id} dense>
          {preset.name}
        </MenuItem>
      ))}
    </Select>
  );
}
